import v2020 from '@/sui/data/sheets/edit/observa4/2020'
import v2021 from '@/sui/data/sheets/edit/observa4/2021'
import v2022 from '@/sui/data/sheets/edit/observa4/2022'
import v2023 from '@/sui/data/sheets/edit/observa4/2023'
import v2024 from '@/sui/data/sheets/edit/observa4/2024'
import v2025 from '@/sui/data/sheets/edit/observa4/2025'
import v2026 from '@/sui/data/sheets/edit/observa4/2026'

import {
  buildConvertFromFieldList
} from '@/sui/data/sheets/convert/tools'

export default {
  '2020': buildConvertFromFieldList(v2020.sheet.fields),
  '2021': buildConvertFromFieldList(v2021.sheet.fields),
  '2022': buildConvertFromFieldList(v2022.sheet.fields),
  '2023': buildConvertFromFieldList(v2023.sheet.fields),
  '2024': buildConvertFromFieldList(v2024.sheet.fields),
  '2025': buildConvertFromFieldList(v2025.sheet.fields),
  '2026': buildConvertFromFieldList(v2026.sheet.fields)
}
